export default __webpack_public_path__ + "static/media/pedidos-force-square-logo.0a16db29.png";